import { SizingMethodApi } from '@voladeum/client';
import { VoladeumResponse } from 'client/types';

import { Axios } from '../../axios';

import { normalizeSizingMethods } from './normalizers';
import { SizingMethod } from './types';

export class VoladeumSizingMethods extends Axios {
  async list(): Promise<VoladeumResponse<SizingMethod[]>> {
    const res = await this.get<VoladeumResponse<SizingMethodApi[]>>('/v1/lookups/sizing-methods');
    return {
      success: res.success,
      error: res.error,
      data: normalizeSizingMethods(res.data),
    };
  }
}
